import React, { useState, useEffect } from 'react';
import { Col, Container, Row, Card, CardBody, TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import AccountingAccountData from './components/AccountingAccount/AccountingAccountData';
import DistributionData from './components/Distribution/DistributionData';

/*************************/
/*
RUT: NIT sin Digito de Verificacion o Cedula
Prefijo: Factura Electronica
Factura_ind: Consecutivo
Fecha Factura: Emision
acct: Cuenta Contable (NUEVO, revisar otro excel)
contable_cr: Subtotal y Copago
contable_db: Subtotal y Copago
-----------------------------------
Cuentas Contables


11050501	CAJA GAMA CALI (Por Sede, van los Copagos en Debito, los Totales tambien van en Debito)
41251040	CONSULTA MEDICA
41251063	GAMAGRAFIAS
41251064	COPAGOS  (COPAGO, va en Crédito)
41251050	MEDICAMENTOS


Particulares en vez de RUT y Cedula se coloca 222222222222

Si es Contributivo o Subsidiado
contable_cr: Cuenta

*/
/***********************************************************/



const AccountingAccount = () => {

    const [activeTab, setActiveTab] = useState('1');
    const [accountingData, setAccountingData] = useState([]);

    useEffect(() => {
        getListAccountingAccount();
    },[]);

    const getListAccountingAccount = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'cajas-contables/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error('Data');
            }
        }).then(response => {
            setAccountingData(response);
        }).catch(err => {
            console.error(err);
        });
    }

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    return (
        <Container className="dashboard">
            <Row>
                <Col md={12}>
                    <h3 className="page-title">Cuentas Contables</h3>
                    <br />
                </Col>
            </Row>
            <Row>
                <Card>
                    <CardBody>
                        <div className="tabs tabs--justify tabs--bordered-top">
                            <div className="tabs__wrap">
                                <Nav tabs>  
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: activeTab === '1' })}
                                            onClick={() => toggle('1')}
                                        >
                                            Cuentas Contables
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: activeTab === '2' })}
                                            onClick={() => toggle('2')}
                                        >
                                            Distribucion
                                        </NavLink>
                                    </NavItem>
                                    {/*
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: activeTab === '3' })}
                                            onClick={() => toggle('3')}
                                        >
                                            Consultas
                                        </NavLink>
                                    </NavItem>*/}
                                </Nav>
                                <TabContent activeTab={activeTab}>
                                    <TabPane tabId="1">
                                        <AccountingAccountData getListAccountingAccount={getListAccountingAccount} accountingData={accountingData} />
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <DistributionData accountingData={accountingData} />
                                    </TabPane>
                                    {/*<TabPane tabId="3">
                                    </TabPane>*/}
                                </TabContent>
                            </div>
                        </div>
                    </CardBody>
                </Card>
            </Row>
        </Container>
    );
}

export default AccountingAccount;
